// Role + status display helpers (backend keeps short keys; UI shows friendly labels).

export const ROLE_LABELS = {
  Estimator: 'Estimator',
  Manager: 'Estimation Manager',
  Admin: 'Admin',
};

export const roleLabel = (r) => ROLE_LABELS[r] || r || '';

export const ROLE_OPTIONS = [
  { value: 'Estimator', label: 'Estimator', hint: 'Builds estimates, submits for approval' },
  { value: 'Manager', label: 'Estimation Manager', hint: 'Edits any estimate, forwards to Admin' },
  { value: 'Admin', label: 'Admin', hint: 'Approves, manages users & master rates' },
];

export const STATUS_LABELS = {
  Draft: 'Draft',
  SubmittedToManager: 'Pending Manager',
  SubmittedToAdmin: 'Pending Admin',
  Approved: 'Approved',
  Rejected: 'Rejected',
  Sent: 'Sent',
  Won: 'Won',
  Lost: 'Lost',
};

export const statusLabel = (s) => STATUS_LABELS[s] || s || '';
